import PptxGenJS from "pptxgenjs";
import {
  BRAND_WATERMARK,
  PAGE_TITLE_TEXT,
  PRIVATE_AND_CONFIDENTIAL_TEXT,
  SPLIT_PANEL_RIGHT,
} from "./components";

export const SPLIT_RIGHT_MASTER = "SPLIT_RIGHT_MASTER";

export const splitRightMasterSlide: PptxGenJS.SlideMasterProps = {
  title: SPLIT_RIGHT_MASTER,
  background: {
    color: "#FFFFFF",
  },
  objects: [
    PAGE_TITLE_TEXT,
    SPLIT_PANEL_RIGHT,
    PRIVATE_AND_CONFIDENTIAL_TEXT,
    BRAND_WATERMARK,
  ],
  slideNumber: {
    x: "50%",
    y: "95%",
    fontSize: 8,
    color: "#000000",
  },
};
